// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { createApp } from 'vue'

// // Components
// import './components'

// Plugins
import './plugins'

import vuetify from './plugins/vuetify'

// Application imports
import AuthPlugin from './plugins/auth'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'
import axios from './plugins/axios'
import { VueReCaptcha } from 'vue-recaptcha-v3'

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Axios
//see plugins/axios.js
axios.defaults.baseURL = AppConfig.spillsapiurl;
axios.defaults.headers.common['Content-Type'] = 'application/json';

const app = createApp(App);

app.config.globalProperties.$http = axios;

app.use(VueReCaptcha, {
    siteKey: '6LcHQrgZAAAAANvRPS1cDeJc7Jn_7N3iA_oNl8JA',
    loaderOptions: {
        autoHideBadge: false,
    }
});
app.use(router);
app.use(store);
app.use(i18n);
app.use(vuetify);
app.use(AuthPlugin);

app.mount('#app')
